import ProductosMasVendidosContainer from './ProductosMasVendidosContainer';
export default ProductosMasVendidosContainer;
